import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type LoanRequestsDuplicatesTableSchema = {
//     matchedApplicantId: string;
//     matchedId: string;
//     originApplicantId: string;
//     originId: string;
// };

export const LoanRequestsDuplicatesTableDefinitionZod = z.object({
    matchedApplicantId: schemaId,
    matchedId: schemaId,
    originApplicantId: schemaId,
    originId: schemaId,
});

export type LoanRequestsDuplicatesTableSchema = z.infer<typeof LoanRequestsDuplicatesTableDefinitionZod>;
